import { useQuery } from '@tanstack/react-query';
import { getShipDeliveries } from '../api/shipApi';
import type { ShipDeliveryList } from '../constants/ship.logic';

/**
 * C-4 목록(C7). 키 ['ship','deliveries',scheduleId]. 팝업 마운트 시에만 호출.
 * 항상 최신: staleTime 0 · 마운트마다 재조회 · 창 포커스 재조회. 오류는 던져서 isError 로 노출(빈 결과 폴백 없음).
 */
export function useShipDeliveries(scheduleId: number | null | undefined) {
  return useQuery<ShipDeliveryList>({
    queryKey: ['ship', 'deliveries', scheduleId],
    queryFn: ({ signal }) => getShipDeliveries(scheduleId as number, signal),
    enabled: scheduleId != null,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
}
